import React, { Component } from 'react';
import moment from 'moment';
import * as searchTypes from '../../../../constants/searchTypes';
import { deleteSearchResultOfType, restoreSearchResultOfType, setResultIndex } from '../../../../actions/searchActions';
import {
  SEARCH_ACTION_SOURCES,
  trackSearchItemSelected,
  trackSearchResultClosed,
  trackSearchResultFeedbackEvent,
} from '../../../../analytics/searchEventAnalytics';
import * as SessionAnalyticsService from 'services/SessionAnalyticsService/SessionAnalyticsService';
import { connect } from 'react-redux';
import {
  extractSelectedTicketFromState,
  getLengthOfSelectedResultList,
  getSearchId,
  getSelectedSearchResultIndex,
  isSearchResultDeleted,
  isSpecialist,
  getSelectedSearchResultType,
} from '../../../../extractFromState';
import { DeleteOrUndoButton, FeedbackButton } from '../../../common/buttonsComponents';
import KnowledgeBaseResultPage from '../KnowledgeBaseResultPage';
import {
  PaginationArrow,
  PaginationButton,
  PaginationText,
  ResultPageWrapper,
  ResultPaginationSection,
} from '../../common/PageLayout.styles';
import { SEARCH_PARTNER_PLATFORM_HISTORICAL_TICKETS } from '../../../../constants/searchTypes';
import isEmpty from 'lodash/isEmpty';
import { setAnchorElementsTarget } from '../../../../util';
import { filterImgLinksfromString } from '../../../../util/kbUtil';
import {
  ButtonHolder,
  MessageWrapper,
  MessageSubject,
  MessageBody,
  MessageDetails,
  FeedbackWrapper,
  ResultFeedback,
  FeedbackDescription,
  FeedbackButtonsWrapper,
  ConversationWrapper,
} from './ResultPage.styles';
import MWResultPage from '../../../MacroWizard/MWResultPage/MWResultPage';
import { handleError } from 'services/ErrorService/ErrorService';

export class ResultPage extends Component {
  state = {
    showFeedbackSuccess: false,
    showCopySuccess: false,
    showCopyMsng: false,
    processing: false,
  };

  componentDidMount() {
    let ticket = this.props.ticket || 'none';
    SessionAnalyticsService.event('Search Item Clicked -  search Result', {
      articleNumber: this.props.searchResult.articleNumber,
      type: this.props.searchResult.type,
      fullSubheading: this.props.searchResult.fullSubheading,
      query: this.props.query,
      smb: ticket.smbName,
    });
  }

  componentDidUpdate(prevProps) {
    // logic here loads up partner platform tickets
    // when switching result page, because partnerPlatformHistoricalTicket might be not fully loaded
    const currResultIndex = this.props.resultIndex;
    const prevResultIndex = prevProps.resultIndex;
    const { selectedSearchResultType, searchResult } = this.props;

    if (
      prevResultIndex !== currResultIndex &&
      selectedSearchResultType === SEARCH_PARTNER_PLATFORM_HISTORICAL_TICKETS
    ) {
      // ticket isn't fully loaded if directions array is empty
      if (isEmpty(searchResult.directions)) {
        this.props.handlePartnerPlatformTicketSelection(currResultIndex);
      }
    }
  }

  trackSearchResultClosed = () => {
    const { SEARCH_MACROS, SEARCH_KB, SEARCH_TICKETS } = searchTypes;
    if ([SEARCH_MACROS, SEARCH_KB, SEARCH_TICKETS].indexOf(this.props.resultType) > -1) {
      const { searchId, ticket, searchResult, resultType } = this.props;

      // also track closing this search result
      trackSearchResultClosed({
        searchId,
        conversationId: ticket.ticketId,
        simplrAccountId: ticket.simplrAccountPtrId,
        algoliaObjectId: searchResult.objectID,
        searchResultType: searchTypes.convertSearchTypeToResultType(resultType),
      }).catch((error) => handleError({ error }));
    }
  };

  incrementPage = () => {
    // for KB, MACROS and HISTORICAL TICKETS track closing result
    this.trackSearchResultClosed();
    this.props.setResultIndex(this.props.resultIndex + 1);
    this.setState({ showFeedbackSuccess: false, showCopySuccess: false });
    trackSearchItemSelected(SEARCH_ACTION_SOURCES.ARROW);
  };

  decrementPage = () => {
    // for KB, MACROS and HISTORICAL TICKETS track closing result
    this.trackSearchResultClosed();
    this.props.setResultIndex(this.props.resultIndex - 1);
    this.setState({ showFeedbackSuccess: false, showCopySuccess: false });
    trackSearchItemSelected(SEARCH_ACTION_SOURCES.ARROW);
  };

  // display feedback success message for 5 seconds
  submitFeedback = (isHelpful) => {
    trackSearchResultFeedbackEvent({
      searchId: this.props.searchId,
      conversationId: this.props.ticket.ticketId,
      simplrAccountId: this.props.ticket.simplrAccountPtrId,
      algoliaObjectId: this.props.searchResult.objectID,
      searchResultType: searchTypes.convertSearchTypeToResultType(this.props.resultType),
      searchResultFeedback: isHelpful ? 'HELPFUL' : 'NOT_HELPFUL',
    }).catch((error) => handleError({ error }));
    this.setState({ showFeedbackSuccess: true });
    setTimeout(() => {
      this.setState({ showFeedbackSuccess: false });
    }, 3000);
  };

  renderTicket = (searchResult) => {
    const messageDate = moment(searchResult.firstMessageArrivedAt).format('MM/DD/YY');

    let searchResultRows =
      searchResult.directions &&
      searchResult.directions.map((direction, index) => {
        let highlightSubject = searchResult._highlightResult.subjects[index].value;
        highlightSubject =
          highlightSubject === 'N/A' || highlightSubject === 'internal note'
            ? null
            : '<b>Subject:</b> ' + filterImgLinksfromString(highlightSubject);
        let highlightMessage = searchResult._highlightResult.messages[index].value;
        highlightMessage = highlightMessage === 'N/A' ? null : filterImgLinksfromString(highlightMessage);

        let messageType;
        switch (direction) {
          case 'INBOUND':
            messageType = '[Customer]';
            break;
          case 'OUTBOUND':
            messageType = '[Expert]';
            break;
          case 'INTERNAL':
            messageType = '[Internal Note]';
            break;
          default:
            handleError({ customMessage: 'Algolia index error' });
        }

        return highlightSubject || highlightMessage ? (
          <MessageWrapper key={`messageWrapper_${index}`} data-testid={'messageWrapper'}>
            <MessageDetails>
              {messageType} {messageDate === 'Invalid date' ? '' : messageDate}
            </MessageDetails>
            {highlightSubject && (
              <MessageSubject dangerouslySetInnerHTML={{ __html: setAnchorElementsTarget(highlightSubject) }} />
            )}
            <MessageBody dangerouslySetInnerHTML={{ __html: setAnchorElementsTarget(highlightMessage) }} />
          </MessageWrapper>
        ) : null;
      });

    return <ConversationWrapper>{searchResultRows}</ConversationWrapper>;
  };

  renderContent() {
    switch (this.props.resultType) {
      case searchTypes.SEARCH_MACROS:
        return <MWResultPage disableScroll={true} searchResult={this.props.searchResult} />;
      case searchTypes.SEARCH_KB:
        return <KnowledgeBaseResultPage searchResult={this.props.searchResult} />;
      default:
        return this.renderTicket(this.props.searchResult);
    }
  }

  render() {
    const { pageLength, resultIndex, resultType, isUserSpecialist, showUndo, undoDelete, trashResult } = this.props;

    const deleteOrUndo = () => {
      if (showUndo) {
        this.setState({ processing: true });
        undoDelete().then(() => {
          this.setState({ processing: false });
        });
      } else {
        this.setState({ processing: true });
        trashResult().then(() => {
          this.setState({ processing: false });
        });
      }
    };

    const buttonLabel = showUndo ? 'undo' : 'delete';
    const showDeleteOrUndo = isUserSpecialist && searchTypes.isDeleteEnabledForSearchType(resultType);

    return (
      <ResultPageWrapper name="result-page-wrapper">
        {this.renderContent()}
        <ResultPaginationSection name="pagination-section">
          <ResultFeedback>
            <FeedbackWrapper>
              {showDeleteOrUndo && (
                <ButtonHolder>
                  <DeleteOrUndoButton disabled={this.state.processing} onClick={() => deleteOrUndo()}>
                    {this.state.processing ? 'Processing' : buttonLabel}
                  </DeleteOrUndoButton>
                </ButtonHolder>
              )}
              <FeedbackDescription>
                {this.state.showFeedbackSuccess ? 'Thank you for your feedback!' : 'Was this search result useful?'}
              </FeedbackDescription>
              <FeedbackButtonsWrapper>
                <FeedbackButton hide={this.state.showFeedbackSuccess} onClick={() => this.submitFeedback(true)}>
                  YES
                </FeedbackButton>
                <FeedbackButton hide={this.state.showFeedbackSuccess} onClick={() => this.submitFeedback(false)}>
                  NO
                </FeedbackButton>
              </FeedbackButtonsWrapper>
            </FeedbackWrapper>
          </ResultFeedback>
          <PaginationButton>
            <PaginationArrow
              onClick={this.decrementPage}
              hide={!(resultIndex > 0)}
              src="/images/arrow-left.svg"
              alt="left-arrow"
            />
            <PaginationText>
              <span>{resultIndex + 1}</span> of <span>{pageLength}</span>
            </PaginationText>
            <PaginationArrow
              onClick={this.incrementPage}
              hide={!(resultIndex + 1 < pageLength)}
              src="/images/arrow-right.svg"
              alt="right-arrow"
            />
          </PaginationButton>
        </ResultPaginationSection>
      </ResultPageWrapper>
    );
  }
}

const mapStateToProps = (state, { searchResult, resultType }) => {
  return {
    ticket: extractSelectedTicketFromState(state),
    resultIndex: getSelectedSearchResultIndex(state),
    pageLength: getLengthOfSelectedResultList(state),
    isUserSpecialist: isSpecialist(state),
    showUndo: isSearchResultDeleted(state, searchResult, resultType),
    searchId: getSearchId(state),
    selectedSearchResultType: getSelectedSearchResultType(state),
  };
};

const mapDispatchToProps = (dispatch, { searchResult, resultType }) => {
  return {
    setResultIndex: (index) => {
      dispatch(setResultIndex(index));
    },
    async trashResult() {
      await dispatch(deleteSearchResultOfType(searchResult, resultType));
    },
    async undoDelete() {
      await dispatch(restoreSearchResultOfType(searchResult, resultType));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ResultPage);
